// How an invitee's annual gift reached them (migration 030, 2026-09-29).
//
// A MIRROR of GIFT_DELIVERY + GIFT_DELIVERY_LABELS in
// api/src/services/symposium-gifts.ts — the API refuses (400) any value not in
// its list and the database CHECK refuses it again. api/test/
// symposium-gifts.test.ts imports THIS file and fails if the two drift, so
// keep it free of imports (the API's test runner loads it directly).
//
// Whether a row still needs mailing is NOT decided here: the API sends
// `giftNeedsMailing` on every invite, computed by its one rule.

export const GIFT_DELIVERY_OPTIONS = [
  { value: 'picked_up', label: 'Picked up at Symposium' },
  { value: 'ordered', label: 'Ordered at Symposium' },
  { value: 'to_mail', label: 'To mail' },
  { value: 'mailed', label: 'Mailed' },
] as const

export type GiftDeliveryValue = (typeof GIFT_DELIVERY_OPTIONS)[number]['value']

/** Display label for a stored value; '' when there is none (or it is unknown). */
export function giftDeliveryLabel(v: unknown): string {
  return GIFT_DELIVERY_OPTIONS.find((o) => o.value === v)?.label ?? ''
}

/** Sort position in the order the options are offered; no delivery sorts first. */
export function giftDeliveryRank(v: unknown): number {
  return GIFT_DELIVERY_OPTIONS.findIndex((o) => o.value === v) + 1
}
